import $const from "@/utils/const";

const state = () => ({});
const mutations = {};
const actions = {
    notifyCustomerProcess(context, payload) {
        switch (payload.type) {
            case $const.SOCKETCLUSTER_NOTI_DATA_TYPE.TICKET_EVENT:
                if (payload.data.event === $const.TICKET_EVENT.NEW_TICKET) {
                    context.dispatch('ticket/addNewTicket', payload.data.ticket, {root: true})
                }
                else if (payload.data.event === $const.TICKET_EVENT.CLOSE_TICKET) {
                    context.dispatch('ticket/processCloseTicketEvent', payload.data.ticket, {root: true})
                }
                break;
            case $const.SOCKETCLUSTER_NOTI_DATA_TYPE.BLOCK_CUSTOMER_EVENT:
                context.commit('customer/updateCurrentCustomer', payload.data, {root: true})
                break;
            case $const.SOCKETCLUSTER_NOTI_DATA_TYPE.UPDATE_AUTO_ASSIGN_CONFIG:
                context.dispatch('autoAssign/onUpdateAutoAssignCfg', payload.data, {root: true})
                break;
            case $const.SOCKETCLUSTER_NOTI_DATA_TYPE.SESSION_EVENT:
                if (payload.data.event === $const.SESSION_EVENT.NEW_SESSION) {
                    context.dispatch('session/processNewSessionEvent', payload.data, {root: true})
                }
                else if (payload.data.event === $const.SESSION_EVENT.END_SESSION) {
                    context.dispatch('session/processEndSessionEvent', payload.data, {root: true})
                }
                break;
            default:
                break
        }
    }
};
const getters = {};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
